import React from 'react'
import PropTypes from 'prop-types'
import { Link, TextCallout1 } from 'blocket-ui'
import styled, { css } from 'styled-components'
import { mediaQueries } from '@blazar-plugins/device'

const StyledCallout = styled(TextCallout1)`
  display: inline-block;
  margin: 2px;
  line-height: inherit;
`

const sharedPillStyle = css`
  padding: 6px 8px;
  border-radius: 4px;
  display: inline-block;

  @media ${mediaQueries.large} {
    padding-left: 0;
    padding-right: 0;
  }
`

export const LinkPill = styled(Link)`
  ${sharedPillStyle}
  font-size: 15px;
  font-family: BlocketSans-Medium, sans-serif;
  background-color: #f9f7f6;
  &:hover {
    color: #4182c3;
  }

  @media ${mediaQueries.large} {
    background-color: transparent;
  }
`

export const SelectedPill = styled.span`
  ${sharedPillStyle}
  background-color: #4182c3;
  color: white;

  @media ${mediaQueries.large} {
    padding-left: 8px;
    padding-right: 8px;
  }
`

export const Count = styled.span`
  font-family: BlocketSans-Regular, sans-serif;
  font-size: 11px;
  color: ${(props) => (props.selected ? 'white' : '#9a9999')};
`

export const Pill = ({ selected, children, to, onClick, external }) => {
  if (selected) {
    return (
      <SelectedPill selected={selected} onClick={onClick}>
        {children}
      </SelectedPill>
    )
  }
  return (
    <LinkPill to={to} onClick={onClick} external={external}>
      {children}
    </LinkPill>
  )
}

Pill.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.node,
  to: PropTypes.string,
  onClick: PropTypes.func,
  external: PropTypes.bool,
}

function ListItem({
  label,
  link,
  adCounter,
  selected,
  trackQuickAssCategoryClick,
  onSecondLevelCategoryClick,
  external,
}) {
  const onClickHandler = (ev) => {
    if (trackQuickAssCategoryClick) {
      trackQuickAssCategoryClick(ev, label)
    }
    if (onSecondLevelCategoryClick) {
      onSecondLevelCategoryClick(link)
    }
  }
  return (
    <StyledCallout tagName="li">
      <Pill
        label={label}
        to={link}
        selected={selected}
        onClick={onClickHandler}
        external={external}
      >
        {label}
        {typeof adCounter === 'number' && <Count selected={selected}>&nbsp;({adCounter})</Count>}
      </Pill>
    </StyledCallout>
  )
}

ListItem.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  adCounter: PropTypes.number,
  selected: PropTypes.bool,
  trackQuickAssCategoryClick: PropTypes.func,
  onSecondLevelCategoryClick: PropTypes.func,
  external: PropTypes.bool,
}

export default ListItem
